import { faFlask } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 6px;
  border: 1px solid ${({ theme }) => theme.colors.foreground.tint};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.foreground.tint};
  font-size: 0.7em;
  font-weight: bold;
  letter-spacing: 0.04em;
  line-height: 1.4;
  text-transform: none;
  vertical-align: middle;
  white-space: nowrap;
`;

type Props = {
  /** Tooltip — säg vad det är som är BETA och vad det betyder för användaren. */
  title?: string;
  className?: string;
};

/**
 * Märker en funktion som BETA: kolven (samma ikon som "Beta-testare" på personalkortet) och
 * ordet BETA. Ersätter användarlistor i Globala inställningar som enda sätt att visa att något
 * är nytt — funktionen syns för alla, och märkningen talar om att den fortfarande förändras.
 */
const BetaBadge: React.FC<Props> = ({
  title = 'Detta är en BETA-funktion',
  className,
}) => (
  <Badge className={className} title={title}>
    <FontAwesomeIcon icon={faFlask} />
    BETA
  </Badge>
);

export default BetaBadge;
